// SkeletonLoader.js
import React from 'react';
import './SkeletonLoader.css'; // Include your CSS for the skeleton loader

function SkeletonLoader({ count = 1, height = 20, width = '100%' }) {
  return (
    <div className="skeleton-container">
      {[...Array(count)].map((_, index) => (
        <div key={index} className="skeleton" style={{ height: `${height}px`, width }} />
      ))}
    </div>
  );
}

export default SkeletonLoader;
